"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OktonGlobalSearch = void 0;
const react_1 = require("@chakra-ui/react");
const react_2 = __importStar(require("react"));
const lu_1 = require("react-icons/lu");
const OktonPlatformProvider_1 = require("../../platform/OktonPlatformProvider");
const OktonGlobalSearch = () => {
    const { client } = (0, OktonPlatformProvider_1.useOktonPlatform)();
    const { isOpen, onOpen, onClose } = (0, react_1.useDisclosure)();
    const [query, setQuery] = (0, react_2.useState)('');
    const [results, setResults] = (0, react_2.useState)([]);
    const [isLoading, setIsLoading] = (0, react_2.useState)(false);
    const colorKbd = (0, react_1.useColorModeValue)('blue.600', 'white');
    const color = (0, react_1.useColorModeValue)('gray.500', 'white');
    const bg = (0, react_1.useColorModeValue)('white', 'gray.800');
    const hoverBg = (0, react_1.useColorModeValue)('gray.100', 'gray.900');
    (0, react_2.useEffect)(() => {
        const handler = (event) => {
            if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 'k') {
                event.preventDefault();
                onOpen();
            }
        };
        window.addEventListener('keydown', handler);
        return () => window.removeEventListener('keydown', handler);
    }, [onOpen]);
    (0, react_2.useEffect)(() => {
        const normalized = query.trim();
        if (!client || normalized.length < 2) {
            setResults([]);
            return;
        }
        const platformClient = client;
        const timer = window.setTimeout(async () => {
            setIsLoading(true);
            try {
                setResults(await platformClient.search(normalized));
            }
            finally {
                setIsLoading(false);
            }
        }, 250);
        return () => window.clearTimeout(timer);
    }, [query, client]);
    return (react_2.default.createElement(react_2.default.Fragment, null,
        react_2.default.createElement(react_1.Button, { colorScheme: "whiteAlpha", color: "white", leftIcon: react_2.default.createElement(react_1.Icon, { as: lu_1.LuSearch, color: "white", fontSize: "18" }), onClick: onOpen },
            react_2.default.createElement(react_1.Flex, { pr: "64" }, "Buscar na plataforma"),
            react_2.default.createElement(react_1.Flex, null,
                react_2.default.createElement(react_1.Kbd, { color: colorKbd }, "Ctrl"),
                "\u00A0+\u00A0",
                react_2.default.createElement(react_1.Kbd, { color: colorKbd }, "K"))),
        react_2.default.createElement(react_1.Modal, { onClose: onClose, isOpen: isOpen, size: "2xl", scrollBehavior: "inside" },
            react_2.default.createElement(react_1.ModalOverlay, null),
            react_2.default.createElement(react_1.ModalContent, { rounded: "2xl", bg: bg },
                react_2.default.createElement(react_1.ModalHeader, null,
                    react_2.default.createElement(react_1.Flex, { as: "label", flex: "1", py: "2", px: "2", alignSelf: "center", color: "gray.200", position: "relative" },
                        isLoading ? react_2.default.createElement(react_1.Spinner, { size: "sm", mr: "4" }) : react_2.default.createElement(react_1.Icon, { as: lu_1.LuSearch, color: colorKbd, fontSize: "26" }),
                        react_2.default.createElement(react_1.Input, { variant: "unstyled", color: color, placeholder: "Buscar na plataforma", _placeholder: { color: 'gray.500' }, size: "lg", ml: "4", autoFocus: true, onChange: event => setQuery(event.target.value), value: query }))),
                results.length > 0 && (react_2.default.createElement(react_1.ModalBody, { pb: "4" }, results.map(result => (react_2.default.createElement(react_1.Box, { key: result.id, bg: bg, borderWidth: "1px", rounded: "2xl", p: "4", mb: "2", cursor: "pointer", _hover: { bg: hoverBg }, onClick: () => window.location.assign(result.url) },
                    react_2.default.createElement(react_1.Text, { fontWeight: "bold", color: color }, result.title),
                    (result.subtitle || result.systemName) && (react_2.default.createElement(react_1.Text, { fontSize: "xs", color: color }, result.subtitle || result.systemName)))))))))));
};
exports.OktonGlobalSearch = OktonGlobalSearch;
//# sourceMappingURL=index.js.map